<div class="flex flex-col gap-1">
  <div class="text-xl font-bold">Details</div>
  <hr />
  <form autocomplete="off" class="flex flex-col gap-1" [formGroup]="bonusEventForm">
    <div class="flex flex-col">
      <div class="form-field-label">
        Name
      </div>
      <mat-form-field appearance="outline">
        <input matInput formControlName="name" type="text" required />
        <mat-error *ngIf="bonusEventForm.controls['name'].hasError('required')">
          Name is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="grid grid-cols-2 gap-2">
      <div class="flex flex-col form-field">
        <div class="form-field-label">
          Starts At
        </div>
        <div class="date-wrap">
          <mat-form-field appearance="outline">
            <input
              matInput
              class="datepicker-input"
              autocomplete="off"
              formControlName="startAt"
              [owlDateTime]="startsAt"
              [owlDateTimeTrigger]="startsAt"
              [max]="bonusEventForm.controls['endAt'].value"
            />
            <span [owlDateTimeTrigger]="startsAt"><i class="material-icons">calendar_today</i></span>
            <owl-date-time #startsAt></owl-date-time>
            <mat-error *ngIf="bonusEventForm.controls['startAt'].hasError('required')">
              Start date is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="form-field-label">
          Ends At
        </div>
        <div class="date-wrap">
          <mat-form-field appearance="outline">
            <input
              matInput
              class="datepicker-input"
              autocomplete="off"
              formControlName="endAt"
              [owlDateTime]="endsAt"
              [owlDateTimeTrigger]="endsAt"
              [min]="bonusEventForm.controls['startAt'].value"
            />
            <span [owlDateTimeTrigger]="endsAt"><i class="material-icons">calendar_today</i></span>
            <owl-date-time #endsAt></owl-date-time>
            <mat-error *ngIf="bonusEventForm.controls['endAt'].hasError('required')">
              End date is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="form-field-label">
        Max Number of Loads (Optional)
      </div>
      <mat-form-field appearance="outline">
        <input sa-number-input matInput formControlName="quota" type="number" />
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <div class="form-field-label">
        Bonus Pricing Type
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="type">
          <mat-option *ngFor="let type of types" [value]="type.value">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="grid grid-cols-2 gap-2">
      <div class="flex flex-col" *ngIf="isFlatRateSelected$$.value">
        <div class="form-field-label">
          Price Value
        </div>
        <mat-form-field appearance="outline">
          <div class="flex justify-center">
            <span matPrefix class="mr-1">$</span>
            <input matInput type="number" formControlName="priceValue" />
          </div>
          <mat-error *ngIf="bonusEventForm.controls['priceValue'].hasError('required')">
            Price is required
          </mat-error>
          <mat-error *ngIf="bonusEventForm.controls['priceValue'].hasError('pattern')">
            Please enter a valid amount.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col" *ngIf="isPercentSelected$$.value">
        <div class="form-field-label">
          Percent Value
        </div>
        <mat-form-field appearance="outline">
          <div class="flex justify-center">
            <input matInput type="number" formControlName="percentValue" />
            <span matSuffix class="ml-1">%</span>
          </div>
          <mat-error *ngIf="bonusEventForm.controls['percentValue'].hasError('required')">
            Percent value is required
          </mat-error>
          <mat-error *ngIf="bonusEventForm.controls['percentValue'].hasError('pattern')">
            Please enter a valid amount.
          </mat-error>
          <mat-error *ngIf="bonusEventForm.controls['percentValue'].hasError('invalidRange')">
            Percent has to be greater than 0 and less than or equal to 30%
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col" *ngIf="isPerTonSelected$$.value">
        <div class="form-field-label">
          Per Ton Value
        </div>
        <mat-form-field appearance="outline">
          <div class="flex justify-center">
            <span matPrefix class="mr-1">$</span>
            <input matInput type="number" min="0" formControlName="perTonValue" />
          </div>
          <mat-error *ngIf="bonusEventForm.controls['perTonValue'].hasError('required')">
            Per Ton value is required
          </mat-error>
        </mat-form-field>
      </div>

      <ng-container *ngIf="isPerApprovedMileSelected$$.value; else bonusPriceCapStandalone">
        <div class="col-span-2 bonus-per-mile-help-text">
          <p class="text-sm" style="color: #5f6368; margin: 0;">
            Approved miles are the billable mileage from the PO setup (loader → well), matching loaded miles on the
            order at completion.
          </p>
        </div>

        <div class="flex flex-col">
          <div class="form-field-label">
            Rate per Approved Mile
          </div>
          <mat-form-field appearance="outline">
            <div class="flex items-center">
              <span matPrefix class="mr-1">$</span>
              <input matInput type="number" min="0" step="0.01" formControlName="perApprovedMileValue" />
              <span matSuffix class="ml-1 bonus-per-mile-suffix">/mi</span>
            </div>
            <mat-error *ngIf="bonusEventForm.controls['perApprovedMileValue'].hasError('required')">
              Amount per approved mile is required
            </mat-error>
            <mat-error *ngIf="bonusEventForm.controls['perApprovedMileValue'].hasError('pattern')">
              Please enter a valid amount.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col">
          <div class="form-field-label">
            Price Cap (Optional)
          </div>
          <mat-form-field appearance="outline">
            <div class="flex items-center">
              <span matPrefix class="mr-1">$</span>
              <input matInput type="number" min="0" step="0.01" formControlName="priceCap" />
            </div>
          </mat-form-field>
        </div>
      </ng-container>
      <ng-template #bonusPriceCapStandalone>
        <div class="flex flex-col" *ngIf="isPercentSelected$$.value || isPerTonSelected$$.value">
          <div class="form-field-label">
            Price Cap (Optional)
          </div>
          <mat-form-field appearance="outline">
            <div class="flex items-center">
              <span matPrefix class="mr-1">$</span>
              <input matInput type="number" min="0" step="0.01" formControlName="priceCap" />
            </div>
          </mat-form-field>
        </div>
      </ng-template>
    </div>

    <div class="flex flex-col gap-2 mb-2">
      <div class="form-field-label">Bonus scope</div>
      <mat-radio-group formControlName="scopeMode" class="flex flex-col gap-2">
        <mat-radio-button value="fracs">Specific fracs</mat-radio-button>
        <mat-radio-button value="regions">Whole region(s)</mat-radio-button>
      </mat-radio-group>
      <p class="text-sm text-gray-600" *ngIf="bonusEventForm.get('scopeMode').value === 'regions'">
        The server applies this bonus to all fracs in the selected LOHI region(s). Mines can only be used with specific
        fracs.
      </p>
    </div>

    <div class="grid grid-cols-2 gap-2">
      <ng-container *ngIf="bonusEventForm.get('scopeMode').value === 'fracs'">
        <div class="border border-gray-400 rounded p-1 flex flex-col">
          <div class="flex flex-row items-center">
            <div class="text-xl font-bold">Fracs</div>
            <mat-icon
              matTooltip="Select one or more fracs to target this bonus"
              class="ml-1cursor-pointer form-field-label"
              >help</mat-icon
            >
          </div>
          <mat-form-field appearance="outline">
            <mat-select multiple [compareWith]="compareFn" formControlName="frac">
              <mat-select-trigger> </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Fracs'"
                  [noEntriesFoundLabel]="'No frac found'"
                  [formControl]="filterFrac"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let frac of filteredFracs$ | async" [value]="frac">
                {{ frac.jobName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-chip-list>
            <mat-chip
              *ngFor="let frac of bonusEventForm.controls['frac'].value; trackBy: trackById; let i = index"
              class="frac-chip flex justify-between"
              (removed)="removeChip('frac', i)"
              [selectable]="true"
              [removable]="!isDisableForm"
            >
              {{ frac.jobName }}
              <mat-icon matChipRemove *ngIf="!isDisableForm">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>

        <div class="border border-gray-400 rounded p-1 flex flex-col">
          <div class="flex flex-row items-center">
            <div class="text-xl font-bold">Mines (Optional)</div>
          </div>
          <mat-form-field appearance="outline">
            <mat-select multiple [compareWith]="compareFn" formControlName="mine">
              <mat-select-trigger> </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Mines'"
                  [noEntriesFoundLabel]="'No mine found'"
                  [formControl]="filterMine"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let mine of filteredMines$ | async" [value]="mine">
                {{ mine.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-chip-list>
            <mat-chip
              *ngFor="let mine of bonusEventForm.controls['mine'].value; trackBy: trackById; let i = index"
              class="frac-chip flex justify-between"
              (removed)="removeChip('mine', i)"
              [selectable]="true"
              [removable]="!isDisableForm"
            >
              {{ mine.name }}
              <mat-icon matChipRemove *ngIf="!isDisableForm">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </ng-container>

      <div
        class="border border-gray-400 rounded p-1 flex flex-col col-span-2"
        *ngIf="bonusEventForm.get('scopeMode').value === 'regions'"
      >
        <div class="flex flex-row items-center">
          <div class="text-xl font-bold">Regions</div>
        </div>
        <mat-form-field appearance="outline">
          <mat-select multiple [compareWith]="compareFn" formControlName="region">
            <mat-select-trigger> </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Regions'"
                [noEntriesFoundLabel]="'No region found'"
                [formControl]="filterRegion"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let region of filteredRegions$ | async" [value]="region">
              {{ region.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-chip-list>
          <mat-chip
            *ngFor="let region of bonusEventForm.controls['region'].value; trackBy: trackById; let i = index"
            class="frac-chip flex justify-between"
            (removed)="removeChip('region', i)"
            [selectable]="true"
            [removable]="!isDisableForm"
          >
            {{ region.name }}
            <mat-icon matChipRemove *ngIf="!isDisableForm">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="border border-gray-400 rounded p-1 flex flex-col col-span-2">
        <div class="flex flex-row items-center">
          <div class="text-xl font-bold">Contracts (optional)</div>
        </div>
        <mat-form-field appearance="outline">
          <mat-select multiple [compareWith]="compareFn" formControlName="contract">
            <mat-select-trigger> </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Contract'"
                [noEntriesFoundLabel]="'No contract found'"
                [formControl]="filterContract"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let contract of filteredContracts$ | async" [value]="contract">
              {{ contract.contractName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-chip-list>
          <mat-chip
            *ngFor="let contract of bonusEventForm.controls['contract'].value; trackBy: trackById; let i = index"
            class="frac-chip flex justify-between"
            (removed)="removeChip('contract', i)"
            [selectable]="true"
            [removable]="!isDisableForm"
          >
            {{ contract.contractName }}
            <mat-icon matChipRemove *ngIf="!isDisableForm">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </form>
</div>
